(function(){
  var el=document.getElementById('sp-data'); if(!el) return;
  var D=JSON.parse(el.textContent), V=D.variants;
  var vid=document.getElementById('sp-vid'), priceEl=document.getElementById('sp-price'), addBtn=document.getElementById('sp-add');
  var addT=document.getElementById('sp-add-t'), addP=document.getElementById('sp-add-p'), form=document.getElementById('sp-form'), msg=document.getElementById('sp-msg');
  var barP=document.getElementById('sp-bar-p'), barBtn=document.getElementById('sp-bar-add'), bar=document.getElementById('sp-bar');
  var fmt=new Intl.NumberFormat('en-GB',{style:'currency',currency:D.currency||'GBP'});
  var money=function(c){return fmt.format(c/100)};
  var cur=V.filter(function(v){return v.id===D.current})[0]||V[0];
  var sel=cur.options.slice();
  var groups=[].slice.call(document.querySelectorAll('.sp-grp'));
  function find(){return V.filter(function(v){return v.options.every(function(o,i){return o===sel[i]})})[0]}
  function update(){
    cur=find()||cur; vid.value=cur.id;
    groups.forEach(function(g,i){
      g.querySelector('.sp-sel').textContent=sel[i];
      [].forEach.call(g.querySelectorAll('.pill'),function(b){
        var v=b.dataset.v; b.classList.toggle('on',v===sel[i]);
        var t=sel.slice(); t[i]=v; var m=V.filter(function(x){return x.options.every(function(o,j){return o===t[j]})})[0];
        b.classList.toggle('out',!(m&&m.available));
      });
    });
    priceEl.textContent=money(cur.price); addP.textContent=money(cur.price); if(barP) barP.textContent=money(cur.price);
    var ok=cur.available; addBtn.disabled=!ok; addT.textContent=ok?'Add to bag':'Sold out'; if(barBtn){barBtn.disabled=!ok;barBtn.textContent=ok?'Add to bag':'Sold out'}
    if(cur.img){var h=document.getElementById('sp-hero'); if(h&&h.src!==cur.img) h.src=cur.img}
    try{var u=new URL(location.href);u.searchParams.set('variant',cur.id);history.replaceState(null,'',u)}catch(e){}
  }
  groups.forEach(function(g,i){g.addEventListener('click',function(e){var b=e.target.closest('.pill'); if(!b) return; sel[i]=b.dataset.v; update()})});
  update();

  document.querySelectorAll('.sp-thumbs button').forEach(function(b){b.addEventListener('click',function(){
    document.getElementById('sp-hero').src=b.dataset.src;
    document.querySelectorAll('.sp-thumbs button').forEach(function(x){x.classList.toggle('on',x===b)});
  })});

  var meas=document.getElementById('sp-meas'), found=document.getElementById('sp-found'), unit='in';
  if(meas){
    var W={Small:18,Medium:20,Large:22,XL:24,'2XL':26,'3XL':28,'4XL':32,'5XL':33};
    document.querySelectorAll('.sp-find .unit button').forEach(function(b){b.addEventListener('click',function(){unit=b.dataset.u;document.querySelectorAll('.sp-find .unit button').forEach(function(x){x.classList.toggle('on',x===b)});calc()})});
    meas.addEventListener('input',calc);
    function calc(){
      var n=parseFloat(meas.value); if(!n){found.hidden=true;return}
      var inch=unit==='cm'?n/2.54:n, best=null, bd=99;
      Object.keys(W).forEach(function(k){var d=Math.abs(W[k]-inch);if(d<bd){bd=d;best=k}});
      found.hidden=false; found.innerHTML='That points to a <b>'+best+'</b>. We’ve picked it for you.';
      var i=0; if(groups.length){var pick=best; if(best==='XL'){var xs=[].map.call(groups[0].querySelectorAll('.pill'),function(b){return b.dataset.v}); if(xs.indexOf('X-Large')>-1) pick='X-Large'}; if(!/^(Small|Medium|Large|X-Large|XL|2XL|3XL|4XL|5XL)$/.test(sel[0]||'')) return; sel[i]=pick; update()}
    }
  }

  document.querySelectorAll('.sp-units button').forEach(function(b){b.addEventListener('click',function(){
    var u=b.dataset.u;
    document.querySelectorAll('.sp-units button').forEach(function(x){x.classList.toggle('on',x===b)});
    document.querySelectorAll('.sp-table td[data-in]').forEach(function(td){var n=+td.dataset.in;td.textContent=u==='cm'?Math.round(n*2.54)+'cm':n+'"'});
  })});
  var place=document.getElementById('sp-place'), printEl=document.getElementById('sp-print');
  if(place&&printEl){place.addEventListener('change',function(e){
    place.querySelectorAll('.sp-opt').forEach(function(o){o.classList.toggle('on',o.querySelector('input').checked)});
    printEl.value=e.target.value;
  })}
  try{if(new URLSearchParams(location.search).get('print')==='front'){
    var fr=document.querySelector('input[name=mh_place][value="Front only"]');
    if(fr){fr.checked=true;fr.dispatchEvent(new Event('change',{bubbles:true}))}
  }}catch(e){}
  var busy=false;
  function add(){
    if(busy||!cur.available) return; busy=true; addT.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'}})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok) throw new Error(res.j.description||res.j.message||'Could not add that');
        addT.textContent='Added ✓';
        return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
          document.querySelectorAll('.mh-bagn').forEach(function(b){b.textContent=c.item_count});
          msg.hidden=false; msg.classList.remove('err'); if(window.pkSyncNote) window.pkSyncNote(); msg.hidden=false; msg.innerHTML='In your bag. <a href="/cart">View bag →</a> or keep browsing.';
        });
      })
      .catch(function(e){msg.hidden=false;msg.classList.add('err');msg.textContent=e.message})
      .then(function(){busy=false;setTimeout(function(){addT.textContent=cur.available?'Add to bag':'Sold out'},1800)});
  }
  form.addEventListener('submit',function(e){e.preventDefault();add()});
  if(barBtn) barBtn.addEventListener('click',add);
  if(bar&&'IntersectionObserver' in window){
    new IntersectionObserver(function(en){en.forEach(function(x){bar.classList.toggle('show',!x.isIntersecting&&x.boundingClientRect.top<0)})}).observe(addBtn);
  }
})();
